import * as React from "react";

import { Box, Heading, Inline, Stack, Text } from "@seneca/senekit";

type Props = {
  className?: string;
  children: {
    title: React.ReactNode;
    counter: React.ReactNode | null | undefined;
    description: React.ReactNode;
  };
};

export default function SidebarContentHeader({
  className,
  children: { title, counter, description }
}: Props) {
  return (
    <Box className={className}>
      <Stack space="xxsmall">
        <Inline alignItems="center" space="large">
          <Heading level="3">{title}</Heading>
          {counter}
        </Inline>
        <Text>{description}</Text>
      </Stack>
    </Box>
  );
}
